var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-inform"},[_c('img',{staticClass:"inform-img",attrs:{"src":require("../assets/common/inform.png"),"alt":""}})])}]

export { render, staticRenderFns }